import { PortalTimeoutChecker } from './Timeout';
import { FipContactBanner } from './FipContactBanner';
(function () {
    switch (window.location.pathname) {
        case '/':
        case '/reset':
        case '/login':
        case '/timeout':
            FipContactBanner.resetForNewLogin();
            break;
        default:
            const timeChecker = new PortalTimeoutChecker(300000);
            timeChecker.start();
            const send = XMLHttpRequest.prototype.send;
            XMLHttpRequest.prototype.send = function (...arg) {
                this.addEventListener('loadend', () => {
                    timeChecker.reset();
                });
                return send.apply(this, arg);
            };
            const originalFetch = window.fetch;
            window.fetch = function (...arg) {
                return originalFetch.apply(this, arg).then((response) => {
                    timeChecker.reset();
                    return response;
                });
            };
            if (window.location.pathname === '/dashboard') {
                new FipContactBanner().init();
            }
            break;
    }
})();
